import React from 'react';

import { useIntl } from 'react-intl';

import { BoltIcon } from 'assets/icons';
import { isAmazonFulfilled } from 'utils/Devices';

interface ShippingBadgeProps {
  shippingProvider: string;
}

export const ShippingBadge = ({ shippingProvider }: ShippingBadgeProps) => {
  const intl = useIntl();

  if (isAmazonFulfilled(shippingProvider)) {
    return (
      <span
        className="rounded d-inline-flex align-items-center gap-1 px-2 py-1 small"
        style={{ backgroundColor: '#E8F5F1', color: '#1D9E75' }}
      >
        <BoltIcon className="icon" style={{ fontSize: '12px' }} />
        {intl.formatMessage({ id: 'deviceShippingAmazonKey' })}
      </span>
    );
  }

  return (
    <span className="rounded bg-light text-secondary px-2 py-1 small">
      {intl.formatMessage({ id: 'deviceShipping35DaysKey' })}
    </span>
  );
};
